import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Viga

  <span style="color:#85c1dc;">**FI:**</span>
  Virhe

  <span style="color:#85c1dc;">**RU:**</span>
  Ошибка
*/
/* @__NO_SIDE_EFFECTS__ */
const m1190 = msg(
  mf`Viga`,
  mf`Virhe`,
  mf`Ошибка`,
)

export { m1190 as 'errors.general.title' }